// Utilities
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
import { lazy } from "react";
export const InfoModalLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-infomodal" */ "@ms/planner-presentational-controls/lib/local/infoModal/InfoModal")).then((bundle)=>{
        return {
            default: bundle.InfoModal
        };
    });
export const LazyInfoModal = /*#__PURE__*/ lazy(InfoModalLazyLoader);
